var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddressicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(-43 -1910)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M12.753,3A5.25,5.25,0,0,0,7.5,8.253c0,3.94,5.253,9.756,5.253,9.756s5.253-5.816,5.253-9.756A5.25,5.25,0,0,0,12.753,3Zm0,7.13A1.876,1.876,0,1,1,14.63,8.253,1.877,1.877,0,0,1,12.753,10.13Z",
    transform: "translate(42.145 1911.67)",
    fill: "none",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(43 1910)",
    fill: "none",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.15,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressicon);
export default __webpack_public_path__ + "static/media/addressicon.cd3179e69fcfc142e68afb300b9a52b9.svg";
export { ForwardRef as ReactComponent };